import { Button } from '@mantine/core';
import { IconArrowLeft, IconHourglassHigh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import classes from './ComingSoon.module.css';
import { type MenuItem, menuStage } from './menu.js';
import { PageHeader } from './PageHeader.js';
import { useShell } from './shell-context.js';

/**
 * Henüz yapılmamış modülün sayfası (ADR 0019 §3): modülün adı, ne yapacağı ve hangi aşamada
 * geleceği. Menü öğesi görünür kalır; yalnız yetki matrisi gizler.
 */
export function ComingSoon({ item, icon }: { item: MenuItem; icon?: MenuItem['icon'] }) {
  const { t } = useTranslation();
  const shell = useShell();
  const stage = menuStage(item, shell?.scope ?? 'web') ?? 'withModules';
  const Icon = icon ?? item.icon ?? IconHourglassHigh;
  const name = t(`menu.${item.id}`);
  // Yalnız ofiste kullanılan ekran (ADR 0026 §1): gemide "hazırlanıyor" değil, bilgi sayfası
  const office = stage === 'office';

  return (
    <>
      {/* Açıklama yalnız kartta: başlıkta tekrar edilmez */}
      <PageHeader title={name} />
      <section className={classes.card} aria-labelledby="coming-soon-title">
        <span className={classes.icon} aria-hidden>
          <Icon size={40} stroke={1.4} />
        </span>
        <span className={classes.badge} data-tone={office ? 'info' : undefined}>
          {t(office ? 'comingSoon.officeBadge' : 'comingSoon.badge')}
        </span>
        <h2 id="coming-soon-title" className={classes.title}>
          {t(office ? 'comingSoon.officeTitle' : 'comingSoon.title')}
        </h2>
        <p className={classes.text}>{t(`comingSoon.modules.${item.id}`)}</p>
        {office ? (
          <p className={classes.note}>{t('comingSoon.officeNote')}</p>
        ) : (
          <>
            <p className={classes.stage}>
              {t('comingSoon.planned', { stage: t(`stages.${stage}`) })}
            </p>
            <p className={classes.note}>{t('comingSoon.reference')}</p>
          </>
        )}
        {shell ? (
          <Button
            component="a"
            href="/dashboard"
            variant="light"
            leftSection={<IconArrowLeft size={16} />}
            onClick={(event) => {
              event.preventDefault();
              shell.navigate('/dashboard');
            }}
          >
            {t('comingSoon.back')}
          </Button>
        ) : null}
      </section>
    </>
  );
}
